/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Mon, Jul 19th 2021, 9:02:34 pm
 *
 * *****************************************************
 */

import type { RouteDef } from 'utils/routes';

import CreateWorkspace from '../views/pages/CreateWorkspace';
import SelectWorkspace from '../views/pages/SelectWorkspace';
import SignIn from '../views/pages/SignIn';
import SignUp from '../views/pages/SignUp';
import VerifyEmail from '../views/pages/VerifyEmail';
import * as authPaths from './paths';

/**
 * Route definitions for authentication
 */
const authRouteDefs: RouteDef[] = [
  {
    path: authPaths.DEFAULT,
    exact: true,
    redirect: authPaths.SIGN_IN
  },
  {
    path: authPaths.SIGN_IN,
    exact: true,
    component: SignIn
  },
  {
    path: authPaths.GET_STARTED_NEW,
    exact: true,
    component: SignUp
  },
  {
    path: authPaths.VERIFY_EMAIL,
    exact: true,
    component: VerifyEmail
  },
  {
    path: authPaths.CREATE_WORKSPACE,
    exact: true,
    component: CreateWorkspace,
    isPrivate: true
  },
  {
    path: authPaths.SELECT_WORKSPACE,
    exact: true,
    component: SelectWorkspace,
    isPrivate: true
  }
];

export default authRouteDefs;
